"use strict";
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.B3InjectEncoding = exports.X_B3_TRACE_ID = exports.X_B3_SPAN_ID = exports.X_B3_SAMPLED = exports.X_B3_PARENT_SPAN_ID = exports.X_B3_FLAGS = exports.B3_CONTEXT_HEADER = exports.B3Propagator = void 0;
var B3Propagator_1 = require("./B3Propagator");
Object.defineProperty(exports, "B3Propagator", { enumerable: true, get: function () { return B3Propagator_1.B3Propagator; } });
var constants_1 = require("./constants");
Object.defineProperty(exports, "B3_CONTEXT_HEADER", { enumerable: true, get: function () { return constants_1.B3_CONTEXT_HEADER; } });
Object.defineProperty(exports, "X_B3_FLAGS", { enumerable: true, get: function () { return constants_1.X_B3_FLAGS; } });
Object.defineProperty(exports, "X_B3_PARENT_SPAN_ID", { enumerable: true, get: function () { return constants_1.X_B3_PARENT_SPAN_ID; } });
Object.defineProperty(exports, "X_B3_SAMPLED", { enumerable: true, get: function () { return constants_1.X_B3_SAMPLED; } });
Object.defineProperty(exports, "X_B3_SPAN_ID", { enumerable: true, get: function () { return constants_1.X_B3_SPAN_ID; } });
Object.defineProperty(exports, "X_B3_TRACE_ID", { enumerable: true, get: function () { return constants_1.X_B3_TRACE_ID; } });
var types_1 = require("./types");
Object.defineProperty(exports, "B3InjectEncoding", { enumerable: true, get: function () { return types_1.B3InjectEncoding; } });
//# sourceMappingURL=index.js.map